import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { MessageCircle } from "lucide-react";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { useLang } from "../../i18n/LangContext";
import { WHATSAPP_URL } from "../../config";

const useSmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
};

const useRouteScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => {
      const el = hash ? document.getElementById(hash.slice(1)) : null;
      const lenis = window.__lenis;
      if (el) lenis ? lenis.scrollTo(el, { offset: -96 }) : el.scrollIntoView();
      else lenis ? lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0);
    }, hash ? 120 : 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);
};

const WhatsAppButton = () => {
  const { t } = useLang();
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fixed-btn"
      aria-label={t.wa}
      className="group fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[#005F60] py-3.5 pl-3.5 pr-3.5 text-[#FAF8F5] shadow-[0_12px_30px_-10px_rgba(0,62,64,0.7)] transition-[padding,background-color] duration-500 hover:bg-[#003E40] sm:hover:pr-5"
    >
      <MessageCircle size={22} />
      <span className="hidden max-w-0 overflow-hidden whitespace-nowrap text-sm transition-[max-width] duration-500 sm:inline group-hover:max-w-[200px]">{t.wa}</span>
    </a>
  );
};

export const Shell = ({ children }) => {
  useSmoothScroll();
  useRouteScroll();
  return (
    <div className="grain relative min-h-screen bg-[#FAF8F5] text-[#121518]">
      <a href="#main" className="sr-only focus:not-sr-only">Saltar para o conteúdo</a>
      <Nav />
      <main id="main">{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};
